import 'rev-less/main.less';
import 'rev-less/video/video-main.less';
import 'rev-less/admin/admin-main.less';
import 'vbrick-icon-font/dist/vb-icon-font.css';
import './embed.less';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { UIRouterModule } from '@uirouter/angular';

import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { AngularAppBootstrapDepsModule } from 'rev-shared/bootstrap/AngularAppBootstrapDeps.Module';
import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { TokenService } from 'rev-shared/security/Token.Service';
import { GoogleAnalyticsModule } from 'rev-shared/ui/googleAnalytics/GoogleAnalytics.Module';
import { MomentLocaleLoader } from 'rev-shared/date/MomentLocaleLoader.Provider';
import { PushModule } from 'rev-shared/push/Push.Module';
import { RootDialogAngularModule } from 'rev-shared/ui/dialog/DialogAngular.Module';
import { SECURITY_STARTUP_INJECTION_TOKEN } from 'rev-shared/security/SecurityStartup.Provider';
import { SecurityAngularModule } from 'rev-shared/security/SecurityAngular.Module';
import { SecurityComponentsModule } from 'rev-shared/security/components/SecurityComponents.Module';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { UiViewContainerComponent } from 'rev-shared/ui/uiViewContainer/UiViewContainer.Component';
import { UtilAngularModule } from 'rev-shared/util/UtilAngular.Module';
import { VBrickSharedPublicVideoPasswordModule } from 'rev-shared/media/publicVideoPassword/PublicVideoPassword.Module';

import { BrandingAngularModule } from 'rev-portal/branding/BrandingAngular.Module';
import { ThemeService } from 'rev-portal/branding/Theme.Service';

import { EMBED_STARTUP_INJECTION_TOKEN } from './EmbedStartup.Provider';
import { EmbedComponent } from './Embed.Component';
import { EmbedPlaylistModule } from './playlist/EmbedPlaylist.Module';
import { EmbedStates, configureEmbedRouter, queryParams } from './EmbedStates';
import { EmbedVideoModule } from './video/EmbedVideo.Module';
import { EmbedLoginModule } from './login/EmbedLogin.Module';
import { TokenHttpInterceptor } from 'rev-shared/security/TokenHttpInterceptor.Service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ENABLE_TOKEN_SERVICE_INJECTION_TOKEN } from 'rev-shared/security/Token.Provider';

@NgModule({
	bootstrap: [EmbedComponent],
	declarations: [
		EmbedComponent
	],
	imports: [ // TODO: whittle some of these away
		AngularAppBootstrapDepsModule,
		BrandingAngularModule,
		BrowserModule,
		DirectivesAngularModule,
		EmbedLoginModule,
		EmbedPlaylistModule,
		EmbedVideoModule,
		GoogleAnalyticsModule,
		PushModule.forRoot(true),
		RootDialogAngularModule,
		SecurityAngularModule,
		SecurityComponentsModule,
		SpinnerAngularModule,
		TooltipModule.forRoot(),
		TranslateModule,
		UIRouterModule.forRoot({
			config: configureEmbedRouter,
			states: EmbedStates,
			useHash: true
		}),
		UiViewContainerComponent,
		UtilAngularModule,
		VBrickSharedPublicVideoPasswordModule
	],
	providers: [{
		provide: EMBED_STARTUP_INJECTION_TOKEN,
		deps: [
			MomentLocaleLoader,
			SECURITY_STARTUP_INJECTION_TOKEN,
			ThemeService
		],
		useFactory: (
			MomentLocaleLoader: MomentLocaleLoader,
			SecurityStartup: Promise<void>,
			ThemeService: ThemeService
		) => {
			return {
				$promise: Promise.all([
					MomentLocaleLoader.load(),
					SecurityStartup,
					ThemeService.initialize()
						.then(() => ThemeService.setCustomThemeMode({
							themeSettings: {
								accentColor: queryParams.accent,
								accentFontColor: queryParams.accentFont,
								primaryColor: queryParams.primary,
								primaryFontColor: queryParams.primaryFont
							}
						}))
				])
					.catch(e => {
						console.error('Embed Startup error: ', e);
						return Promise.reject(e);
					})
			};
		}
	}, {
		provide: HTTP_INTERCEPTORS,
		useClass: TokenHttpInterceptor,
		multi: true
	}, {
		provide: ENABLE_TOKEN_SERVICE_INJECTION_TOKEN,
		useValue: true
	}]
})
export class EmbedModule {}
